require('./contactCenterExternalTransferFundStep4.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @ components
const { FundLegalConfirmation } = require('components/contactCenter/brokerLegalConfirmation/fundLegalConfirmation/fundLegalConfirmation');
const ExternalTransferFundStep4 = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFundStep4/externalTransferFundStep4');
// @ utilities
const { formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper.js');
//@constants
const { PRODUCT_TYPE, TRANSFER_ORDER_TYPE } = require('constants/contactCenter/brokerFundsSendEmailConstants');
const { FIRST_STEP, FOURTH_STEP, BROKER_DOCUMENT_TYPE, BROKER_ORDER_TYPE_BUY } = require('constants/index');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');

class ContactCenterExternalTransferFundStep4 extends React.Component {
    constructor(props){
        super(props);
        this.handleYesNoOptionChange = this.handleYesNoOptionChange.bind(this);
    }

    componentWillUnmount() {
        const { resetPrecontractualMail, resetLegalInformation } = this.props;

        resetPrecontractualMail();
        resetLegalInformation();
    }

    handleYesNoOptionChange(value) {
        const {setLegalInformationConf} = this.props;
        setLegalInformationConf(value);
    }

    getSelectedDestinationFund() {
        const { immExternalTransferFund, immBrokerMyInvestments } = this.props;
        const immFunds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);
        const selectedDestinationFund = immExternalTransferFund.getIn([
            'steps',
            2,
            'destinationFund'
        ]);

        return immFunds.find(immFund => immFund.get('id') == selectedDestinationFund);
    }

    buildInlineErrors() {
        const { immExternalTransferFund } = this.props;

        const checkedIsValid = immExternalTransferFund.getIn(['steps', FOURTH_STEP, 'checkedIsValid']);
        const mailSent = immExternalTransferFund.getIn(['steps', FOURTH_STEP, 'mailSent']);
        const yesSelected = immExternalTransferFund.getIn(['steps', FOURTH_STEP, 'legalInfoChecked']) === SELECTED_VALUES.YES;

        const mailLabelError = !mailSent ? formatText('brokerInternalTransferFund-confirmationErrorMailInvalid') : null;
        const yesSelectedLabelError = !yesSelected ? formatText('brokerInternalTransferFund-confirmationErrorYesNoOptionInvalid') : null;

        if(!checkedIsValid){
            return(
                <div className="contact-center-external-fund-step-4__errors">
                    <p>{mailLabelError}</p>
                    <p>{yesSelectedLabelError}</p>
                </div>
            );
        }
        else {
            return null;
        }
    }

    buildExternalTransferFundStep() {
        const {
            immExternalTransferFund,
            immBrokerFundLegalDocument,
            setCheckbox,
            postValidation,
            fetchLegalDocuments,
            immBrokerMyInvestments

        } = this.props;

        const mailSent = immExternalTransferFund.getIn(['steps', FOURTH_STEP, 'mailSent']);
        const yesSelected = immExternalTransferFund.getIn(['steps', FOURTH_STEP, 'legalInfoChecked']) === SELECTED_VALUES.YES;

        const classes = classNames({
            'hidden-md':!(mailSent && yesSelected)
        });

        return (
            <div className={classes}>
                <ExternalTransferFundStep4
                    immExternalTransferFund={immExternalTransferFund}
                    immBrokerFundLegalDocument={immBrokerFundLegalDocument}
                    setCheckbox={setCheckbox}
                    postValidation={postValidation}
                    fetchLegalDocuments={fetchLegalDocuments}
                    immBrokerMyInvestments={immBrokerMyInvestments}
                />
            </div>
        );
    }

    render() {
        const {
            immBrokerFundLegalDocument,
            immProfileFields,
            requestProfile,
            immExternalTransferFund,
            fetchLegalDocuments,
            immPreContractualMail,
            sendPreContractualMail,
            resetPrecontractualMail
        } = this.props;

        const destinationFund = this.getSelectedDestinationFund();
        const fundIsin = destinationFund.get('isin');
        const fundSecId = destinationFund.get('secID');
        const fundName = destinationFund.get('name');
        const legalInfoOptionChecked = immExternalTransferFund.getIn(['steps',FOURTH_STEP, 'legalInfoChecked']);
        const errors = this.buildInlineErrors();
        const externalTransferFundStep4 = this.buildExternalTransferFundStep();
        const sendMarketingReport = immExternalTransferFund.getIn(['steps', FIRST_STEP, 'hasNif']);

        const emailParams = {
            email: PersonalDataHelper.getEmail(immProfileFields),
            isin: fundIsin,
            isinDescribe: fundName,
            orderType: TRANSFER_ORDER_TYPE,
            productType: PRODUCT_TYPE
        };

        return (
            <div>
                <FundLegalConfirmation
                    fundIsin={fundIsin}
                    fundSecId={fundSecId}
                    fundName={fundName}
                    immProfileFields={immProfileFields}
                    immPreContractualMail={immPreContractualMail}
                    sendMail={sendPreContractualMail}
                    sendMailParams={emailParams}
                    resetMailState={resetPrecontractualMail}
                    selectedYesNoOption={legalInfoOptionChecked}
                    requestProfile={requestProfile}
                    onYesNoOptionChange={this.handleYesNoOptionChange}
                    fetchLegalDocuments={fetchLegalDocuments}
                    immBrokerFundLegalDocument={immBrokerFundLegalDocument}
                    costDocumentType={BROKER_DOCUMENT_TYPE}
                    costOrderType={BROKER_ORDER_TYPE_BUY}
                    sendMarketingReport={sendMarketingReport}
                />
                {errors}
                {externalTransferFundStep4}
            </div>
        );
    }
}

ContactCenterExternalTransferFundStep4.propTypes = {
    immExternalTransferFund: PropTypes.object.isRequired,
    immBrokerFundLegalDocument: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    setCheckbox: PropTypes.func.isRequired,
    postValidation: PropTypes.func.isRequired,
    fetchLegalDocuments: PropTypes.func.isRequired,
    setLegalInformationConf: PropTypes.func.isRequired,
    resetLegalInformation: PropTypes.func.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired
};

module.exports = ContactCenterExternalTransferFundStep4;
